<div class="rounded-lg p-6 shadow-sm border bg-blue-50 border-blue-200">
  <div class="flex mb-4">
    <h2 class="text-lg font-semibold">
      {{ question.question }}<span *ngIf="question.is_required" class="text-red-500"> *</span>
    </h2>
  </div>
  <div class="mt-4">
    <div class="hidden md:flex justify-between mb-2 px-4">
      <div
        *ngFor="
          let option of [
            'Definitely',
            'Very likely',
            'Possibly',
            'Unlikely',
            'Not at all',
            'Not applicable',
          ];
          let i = index
        "
        class="text-sm font-medium text-gray-600 w-1/5 text-center"
      >
        <label [for]="'likert-scale-2-' + question.uuid + '-' + i" class="cursor-pointer">{{
          option
        }}</label>
      </div>
    </div>

    <div class="md:flex md:justify-between md:items-center md:px-4">
      <div
        *ngFor="
          let option of [
            'Definitely',
            'Very likely',
            'Possibly',
            'Unlikely',
            'Not at all',
            'Not applicable',
          ];
          let i = index
        "
        class="flex items-center justify-between p-3 border border-gray-200 rounded-lg hover:bg-blue-50 transition-colors mb-4 md:mb-0 md:w-1/5 md:flex-col md:border-0 md:p-0 md:hover:bg-transparent"
      >
        <label
          [for]="'likert-scale-2-' + question.uuid + '-' + i"
          class="flex-grow cursor-pointer md:hidden"
        >
          {{ option }}</label
        >
        <div class="relative flex items-center justify-center md:mb-0">
          <input
            type="radio"
            [id]="'likert-scale-2-' + question.uuid + '-' + i"
            disabled
            class="appearance-none h-5 w-5 border-2 border-blue-300 rounded-full checked:bg-blue-500 checked:border-blue-500 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 transition-all cursor-pointer"
          />
        </div>
      </div>
    </div>
  </div>
</div>
